import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaBell, FaInfoCircle, FaMoon, FaSearch, FaUser } from "react-icons/fa";
import Dashboard from "../pages/General/Dashboard";
import ProductList from "../pages/General/ProductList";
import CreateProduct from "../pages/General/CreateProduct";
import AddCategory from "../pages/General/AddCategory";
import CategoryManagement from "../pages/General/CategoryManagement";
import AllOrders from "../pages/General/AllOrders";
import OrderManagement from "../pages/General/OrderManagement";
import HomeBannerChanges from "../pages/website-changes/HomBannerChanges";
import CategoryChanges from "../pages/website-changes/CategoryChanges";
import TopSellingProductsBanner from "../pages/website-changes/TopSellingProductsBanner";
import TopFeaturedProductsRollingText from "../pages/website-changes/TopFeaturedProductsRollingText";
import SponsorPage from "../pages/website-changes/SponsorPage";

const MainContent = ({ selectedItem }) => {
  const componentMap = {
    Dashboard: <Dashboard />,
    ProductList: <ProductList />,
    CreateProduct: <CreateProduct />,
    "Add Category": <AddCategory />,
    "Category Management": <CategoryManagement />,
    "All Orders": <AllOrders />,
    "Order Management": <OrderManagement />,
    "HomeBannerChanges": <HomeBannerChanges />,
    "CategoryChanges": <CategoryChanges />,
    "TopSellingProductsChanges": <TopSellingProductsBanner />,
    "TopFeaturedProductsRollingTextChanges": <TopFeaturedProductsRollingText />,
    "SponoserPage": <SponsorPage />,
  };

  return (
    <motion.div 
      className="flex flex-col h-full bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 rounded-lg shadow-xl overflow-hidden w-full max-w-[100vw]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {/* Header */}
      <motion.header
        className="sticky top-0 z-10 bg-gradient-to-r from-purple-600 via-indigo-600 to-blue-600 text-white p-4 rounded-t-lg shadow-lg backdrop-blur-md transition-all duration-300 ease-in-out w-full"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center w-full">
          {/* Title Section */}
          <div className="flex-shrink-0 w-full sm:w-auto">
            <motion.p 
              className="text-xs md:text-sm text-indigo-200"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              Pages / {selectedItem}
            </motion.p>
            <motion.h1 
              className="text-xl md:text-3xl font-bold truncate"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
            >
              {selectedItem}
            </motion.h1>
          </div>

          {/* Search and Icons Section */}
          <div className="flex items-center space-x-4 bg-white bg-opacity-20 px-4 py-2 rounded-full shadow-inner w-full sm:w-auto">
            {/* Search Bar */}
            <div className="flex items-center bg-white bg-opacity-30 rounded-full px-3 py-1 shadow-inner flex-1 sm:flex-initial">
              <FaSearch className="text-indigo-200 mr-2" />
              <input
                type="text"
                placeholder="Search..."
                className="bg-transparent focus:outline-none text-sm md:text-base text-white placeholder-indigo-200 w-full sm:w-40 md:w-auto"
              />
            </div>

            {/* Icons */}
            <div className="flex items-center space-x-4">
              {[FaBell, FaInfoCircle, FaMoon].map((Icon, index) => (
                <motion.div
                  key={index}
                  whileHover={{ scale: 1.2, rotate: 15 }}
                  whileTap={{ scale: 0.8 }}
                >
                  <Icon className="text-indigo-200 hover:text-white transition cursor-pointer text-lg md:text-xl" />
                </motion.div>
              ))}

              {/* User Profile Circle */}
              <motion.div 
                className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-indigo-800 text-white flex items-center justify-center font-bold shadow-lg cursor-pointer"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaUser />
              </motion.div>
            </div>
          </div>
        </div>
      </motion.header>

      {/* Main Content Section */}
      <div className="flex-1 overflow-y-auto p-4 sm:p-6 w-full">
        <AnimatePresence mode="wait">
          <motion.div
            key={selectedItem}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="w-full max-w-full overflow-x-hidden bg-white rounded-lg shadow-lg p-6"
          >
            {componentMap[selectedItem] || (
              <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
                Welcome to the <strong className="text-indigo-600">{selectedItem}</strong> page. 
                Here you'll find details and actions related to <strong className="text-indigo-600">{selectedItem}</strong>.
              </p>
            )}
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Footer */}
      <motion.footer
        className="sticky bottom-0 bg-gradient-to-r from-purple-600 via-indigo-600 to-blue-600 text-white py-3 px-4 md:px-6 rounded-b-lg shadow-lg w-full"
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        
      </motion.footer>
    </motion.div>
  );
};

export default MainContent;

